/** The camera's zoom as a CSS variable on a selected or hovered card, read by its screen-space rings. */
export const CANVAS_ZOOM_VAR = "--canvas-zoom";

/** Marks a small element that reads the zoom while its card is idle; the zoom is written on it alone, so only its own subtree restyles. */
export const CANVAS_ZOOM_TARGET = "data-canvas-zoom";

/** A length in screen px: the camera scales the card, so the zoom is divided back out. */
export const screenPx = (px: number) =>
  `calc(${px}px / var(${CANVAS_ZOOM_VAR}, 1))`;

/** A length that scales with the card when zoomed out but never draws larger than `px` on screen when zoomed in. */
export const cappedScreenPx = (px: number) => `min(${px}px, ${screenPx(px)})`;

/** Hands one card the camera's zoom for its screen-px rings, on the card itself so nothing else restyles. */
export function writeCardZoom(element: Element | null, zoom: number) {
  element
    ?.closest<HTMLElement>(".react-flow__node")
    ?.style.setProperty(CANVAS_ZOOM_VAR, String(zoom));
}
